import { useMemo } from 'preact/hooks'
import useLoadedEntity from 'lib/useLoadedEntityHook'

export const getEntityKey = organizationApikey =>
  `hierarchicalNetworkMembers:${organizationApikey}`

export function useHierarchicalNetworkMembers(organizationApikey, componentName) {
  const entityKey = getEntityKey(organizationApikey)

  const {
    hierarchicalNetworkMembers,
    hierarchicalNetworkMembersLoading,
    hierarchicalNetworkMembersLoadingError,
  } = useLoadedEntity({
    entityKey,
    entityName: 'hierarchicalNetworkMembers',
    loadEntity: takeAction => {
      return takeAction('hierarchicalNetworkMembers.load', organizationApikey)
    },
    componentName,
  })

  const result = useMemo(() => {
    if (!hierarchicalNetworkMembers) return {
      networkType: null,
      masterOrganization: null,
      members: [],
      relationships: [],
    }
    return {
      networkType: hierarchicalNetworkMembers.networkType,
      masterOrganization: hierarchicalNetworkMembers.masterOrganization,
      members: hierarchicalNetworkMembers.members || [],
      relationships: hierarchicalNetworkMembers.relationships || [],
    }
  }, [hierarchicalNetworkMembers])

  return {
    ...result,
    hierarchicalNetworkMembers,
    hierarchicalNetworkMembersLoading,
    hierarchicalNetworkMembersLoadingError,
  }
}
